import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

type RequestNewSmsData = {
  requestNewSms: {
    id: GQL_ID
    timeout: number
    sent: boolean
    error: Error
  }
}

type RequestNewSmsVariables = {
  id: GQL_ID
}

export const GQL_MUTATION_REQUEST_NEW_SMS = gql`
  mutation requestNewSms($id: ID!) {
    requestNewSms(id: $id) {
      id
      timeout
      sent
      error
    }
  }
`

export const useRequestNewSms = () => useMutation<RequestNewSmsData, RequestNewSmsVariables>(GQL_MUTATION_REQUEST_NEW_SMS)
